export const itemBoxStyle = {
  getOverflowStyle: data => ({ vertical: data.length > 1 ? 'scroll' : 'hidden' }),
  borderStyle: {
    side: 'all',
    color: 'light-3',
    size: 'small',
  },
  height: { max: '200px' },
}

export const itemListBoxStyle = {
  height: { min: '150px' },
  fxWidth: { large: '170px', other: '75px' },
}

export const titleBoxStyle = {
  pad: { top: '15px', bottom: '15px' },
}
